var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{attrs:{"id":"qymap"}}),_vm._v(" "),_c('div',{attrs:{"id":"qytable"}},[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.tableData,"no-data-text":"<div class='table-no-data'></div>","height":_vm.utils.setTableHeight(100)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62834ba8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/garbage/ljqymx.vue
// module id = null
// module chunks = 